import axios, { type AxiosError } from 'axios';
import axiosRetry from 'axios-retry';
import authService from 'src/services/authService';
import { isUnauthorizedError } from 'src/utils/clientHelpers';

// new api client for Tanstack
export const rtwClient = axios.create({
  baseURL: 'https://prod.na.rtw-api.whs.amazon.dev',
});

axiosRetry(rtwClient, {
  retries: 1, // number of retries
  retryDelay: (retryCount: number) => {
    console.info(`retry attempt: ${retryCount}`);
    authService.login(rtwClient);
    return retryCount * 2000; // time interval between retries
  },
  retryCondition: (error: AxiosError) => {
    // if retry condition is not specified, by default idempotent requests are retried
    console.error(JSON.stringify(error));
    return isUnauthorizedError(error);
  },
});

export default rtwClient;
